"use client";

import { PaginationType } from "@/types/pagination.type";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, IconButton } from "@mui/material";
import useUrlParams from "@/hooks/url";
import { useEffect } from "react";

export default function Pagination({ links }: { links: PaginationType }) {
  const { searchParams, updateURLParams } = useUrlParams();

  const previous = () => {
    if (links.prev) {
      updateURLParams({ page: links.prev.split("=")[1] });
    }
  };

  const next = () => {
    if (links.next) {
      updateURLParams({ page: links.next.split("=")[1] });
    }
  };

  if (!(links.next !== null || links.prev !== null)) return null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchParams.toString()]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
      <IconButton disabled={!Boolean(links.prev)} onClick={previous}>
        <ChevronLeftRoundedIcon />
      </IconButton>
      <IconButton disabled={!Boolean(links.next)} onClick={next}>
        <ChevronRightRoundedIcon />
      </IconButton>
    </Box>
  );
}
